import { useEffect } from "react";

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        // Portaled overlays (e.g. NumPad) that live outside the ref's DOM tree.
        event?.target?.closest?.("[data-ignore-click-outside]") ||
        (event?.target?.className !== undefined &&
          typeof event?.target?.className === "string" &&
          event?.target?.className.includes("react-select__option"))
      ) {
        return;
      }
      handler?.(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
